export enum AccountingLineColumnSort {
  createdAt = 'createdAt',
  debtState = 'debtState',
  expiresAt = 'invoice.expiresAt',
  id = 'id',
  description = 'description',
  amount = 'amount'
}
